export const PUBLIC_ROUTE = {
  ROOT: "/",
  LOGIN: "/login",
  LANDING: "/user",
  PAGE_404: "/404",
  PAGE_500: "/500",
};
